(function () {
  if (window.__ubfBuy2Bound) return;
  window.__ubfBuy2Bound = true;

  function fallbackCopy(code) {
    var input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.top = '0';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, code.length);
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (err) {
      ok = false;
    }
    document.body.removeChild(input);
    return ok;
  }

  function showCopied(button) {
    var original = button.getAttribute('data-buy2-label') || button.textContent;
    var copied = button.getAttribute('data-buy2-copied') || original;
    button.textContent = copied;
    window.setTimeout(function () {
      button.textContent = original;
    }, 2000);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-buy2-copy]');
    if (!button) return;
    event.preventDefault();
    var code = button.getAttribute('data-buy2-copy') || '';
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        showCopied(button);
      }).catch(function () {
        if (fallbackCopy(code)) showCopied(button);
      });
      return;
    }

    if (fallbackCopy(code)) showCopied(button);
  });
})();
